import { config } from 'config';

export function getApiUrl({ path }: { path: string }) {
  return `${config.api.baseUrl}/${config.api.version}${path}`;
}
